import styled, { css } from 'styled-components';
import { UiColors } from 'assets/styles/old/global';

const TONES = {
  neutral: css`
    background: ${UiColors.headerTableGray};
    color: ${UiColors.dimGreyFillColor};
  `,
  progress: css`
    background: #fff1e8;
    color: ${UiColors.orangeColor};
  `,
  success: css`
    background: #e6f4ea;
    color: #1e7e34;
  `,
  warn: css`
    background: ${UiColors.peachColor};
    color: ${UiColors.orangeColor};
  `,
  danger: css`
    background: #fdecec;
    color: ${UiColors.errorColor};
  `,
};

const DOT_TONES = {
  neutral: UiColors.brownColor,
  progress: UiColors.mangoColor,
  success: '#28a745',
  warn: UiColors.mangoColor,
  danger: UiColors.errorColor,
};

export const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  white-space: nowrap;

  ${({ tone }) => TONES[tone] || TONES.neutral}
`;

export const Dot = styled.span`
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex: 0 0 auto;
  background: ${({ tone }) => DOT_TONES[tone] || DOT_TONES.neutral};
`;
